import { interactableHeight } from '@cbhq/cds-common/tokens/interactableHeight';
import { HStack } from '@cbhq/cds-web/layout';
import { Fallback } from '@cbhq/cds-web/layout/Fallback';

import { useClientProps } from '../ProfileMenu/providers/ClientPropsProvider';
import { PACKAGE_VERSION_NAME } from '../version';

export function TopRightFallback() {
  const { end: endAppendage, showHelpMenu } = useClientProps();
  const size = interactableHeight.compact;

  return (
    <HStack data-version={PACKAGE_VERSION_NAME} gap={1} alignItems="center" testID="TopRight">
      {endAppendage}
      {showHelpMenu && <Fallback width={size} height={size} shape="circle" />}
      <Fallback width={size} height={size} shape="circle" testID="TopRightFallback1" />
      <Fallback width={size} height={size} shape="circle" testID="TopRightFallback2" />
    </HStack>
  );
}
